import { get, set } from './configuration';
import { init } from './init';

export default {
	get,
	set,
    init
};